import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import i18n from './i18n';
import '../styles-v2/Home.css';
import image1 from '../Image/img 1.jpg';
import image2 from '../Image/img 2 (2).jpg';
import image3 from '../Image/img 9.jpg';
import image4 from '../Image/img 5.jpg';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const Home = () => {
    const { t } = useTranslation();
    const { lang } = useParams(); // Obtenemos el "es" o "en" de la URL

    const [isHomeVisible, setIsHomeVisible] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    // 3. Sincronización obligatoria con la URL
    useEffect(() => {
        if (lang && i18n.language !== lang) {
            i18n.changeLanguage(lang);
        }
    }, [lang]);

    const images = [
        { src: image1, alt: t('home.alt_pressure') },
        { src: image2, alt: t('home.alt_fire') },
        { src: image3, alt: t('home.alt_bg3') },
        { src: image4, alt: t('home.alt_bg4') },
    ];

    useEffect(() => {
        setIsHomeVisible(true);
        if (images.length === 0) return;
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [images.length]);

    return (
        <>
        <Helmet>
            {/* Título dinámico */}
            <title>{t('seo.title')}</title>

            {/* Descripción dinámica */}
            <meta name="description" content={t('seo.description')} />

            {/* Etiquetas Open Graph (para cuando compartes por WhatsApp/LinkedIn) */}
            <meta property="og:title" content={t('seo.title')} />
            <meta property="og:description" content={t('seo.description')} />

            {/* Idioma del documento HTML */}
            <html lang={i18n.language} />
        </Helmet>

        <div>
            <section id="home" className="section home-section">
                <div className="home-background-slider">
                    {images.map((image, index) => (
                        <img
                            key={index}
                            src={image.src}
                            alt={image.alt}
                            className={`slider-image ${currentImageIndex === index ? 'active' : ''}`}
                        />
                    ))}
                    <div className="overlay" />
                </div>

                <div className={`hero-content-box ${isHomeVisible ? 'is-visible' : ''}`}>
                    <p className="hero-subtitle">
                        {t('home.subtitle')}
                    </p>
                    <h1 className="hero-title">
                        {t('home.title')}
                    </h1>
                    <p className="hero-slogan">
                        {t('home.slogan')}
                    </p>
                </div>

                <div className="slider-dots">
                    {images.map((_, index) => (
                        <span
                            key={index}
                            className={`dot ${currentImageIndex === index ? 'active' : ''}`}
                            onClick={() => setCurrentImageIndex(index)}
                        ></span>
                    ))}
                </div>
            </section>
        </div>
        </>
    );
};

export default Home;